import React from 'react';
import { useLocation } from 'react-router-dom';
import AppErrorPage from './AppErrorPage';
import { NOT_FOUND_ERROR } from '../../errors';

const NotFoundPage: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <AppErrorPage
      error={{
        ...NOT_FOUND_ERROR,
        detail: `No route matches "${pathname}". Check the address or use the sidebar to navigate.`,
      }}
    />
  );
};

export default NotFoundPage;
